import { jsx as _jsx, jsxs as _jsxs } from "react/jsx-runtime";
import { MdCode, MdAddCircle, MdMoreVert } from 'react-icons/md';
import { IoMdArrowDropdown } from 'react-icons/io';
import styles from './SelectButton.module.css';
import { classNames } from '../../utils';
export const SelectButtonIcon = ({ variant, disabled, }) => {
    switch (variant) {
        case 'arrowDropdown':
            return (_jsx(IoMdArrowDropdown, { size: 16, className: classNames(styles.arrowIcon, disabled ? styles.disabled : ''), 
                //@ts-ignore
                disabled: disabled }, void 0));
        case 'menu':
            return (_jsx(MdMoreVert, { size: 16, className: classNames(styles.icon, disabled ? styles.disabled : ''), 
                //@ts-ignore
                disabled: disabled }, void 0));
        case 'add':
            return (_jsx(MdAddCircle, { size: 18, className: classNames(styles.addIcon, disabled ? styles.disabled : ''), 
                //@ts-ignore
                disabled: disabled }, void 0));
        case 'select':
        default:
            return (_jsx(MdCode, { size: 16, className: classNames(styles.selectIcon, disabled ? styles.disabled : ''), 
                //@ts-ignore
                disabled: disabled }, void 0));
    }
};
const SelectButton = ({ className, variant = 'select', size = 'medium', onClick = () => { }, close, children, error, isDropdownOpen, disabled, hasSelectedItem, noBottomLine, iconPosition = 'left', fullWidth = true, selectButtonContainerClassName, }) => (_jsxs("div", Object.assign({ className: classNames(styles.root, selectButtonContainerClassName, disabled ? styles.disabled : '', variant ? styles[variant] : '', size ? styles[size] : '', hasSelectedItem ? styles.hasSelectedItem : '', noBottomLine ? styles.noBottomLine : '', fullWidth ? styles.fullWidth : '', isDropdownOpen ? styles.active : '', error ? styles.hasError : ''), onClick: !disabled
        ? (e) => {
            onClick === null || onClick === void 0 ? void 0 : onClick(e);
            close === null || close === void 0 ? void 0 : close();
        }
        : undefined }, { children: [iconPosition === 'left' && (_jsx("div", Object.assign({ className: styles.iconWrapper }, { children: _jsx(SelectButtonIcon, { variant: variant, disabled: disabled }, void 0) }), void 0)), _jsx("div", Object.assign({ className: className, "data-testid": "select-button-item" }, { children: children && hasSelectedItem ? children : '- Select -' }), void 0), iconPosition === 'right' && (_jsx("div", Object.assign({ className: styles.iconWrapper }, { children: _jsx(SelectButtonIcon, { variant: variant, disabled: disabled }, void 0) }), void 0))] }), void 0));
export default SelectButton;
